import { MsalProvider } from '@azure/msal-react';
import './App.css';

import Template from "./pages/Template";

function App({ instance }) {
  return (
    <div className="App">
      <MsalProvider instance={instance}>
           <Template />
      </MsalProvider>
      
    </div>
  );
}

export default App;
